// extracted by mini-css-extract-plugin
export default {"icon":"src-views-mediaLibrary-MediaLibraryFilters-MediaLibraryFilters__icon--xR9Bz","filterItem":"src-views-mediaLibrary-MediaLibraryFilters-MediaLibraryFilters__filterItem--iEgUv"};